import { render } from "./ExternalSystemsSection.vue?vue&type=template&id=2e8481bf"
import script from "./ExternalSystemsSection.vue?vue&type=script&lang=js"
export * from "./ExternalSystemsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__